var _react_refresh_temp_1;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import './style.scss';
const Loading = ({ text }) => {
    return (_jsx("div", { className: `loader opacity-1 fixed top-0 left-0 w-full h-full bg-white/90 dark:bg-darkPrimary/90 z-[999] flex flex-wrap items-center justify-center`, children: _jsxs("div", { className: "inner", children: [_jsxs("div", { className: "lds-ripple", children: [_jsx("div", { className: "border-secondaryColor" }), _jsx("div", { className: "border-secondaryColor" })] }), _jsx("p", { className: "block w-full text-center relative bottom-4 capitalize dark:text-darkText", children: text })] }) }));
};
_react_refresh_temp_1 = Loading;
$RefreshReg$(_react_refresh_temp_1, "Loading");
export default Loading;
